module.exports = __webpack_public_path__ + "img/lilo.ebcb3627.png";